import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { membersService } from '../api/members.service';
import { MEMBERS_KEYS } from './queryKeys';
import type { UpdateMemberPayload } from '../types';

/**
 * Calls PUT /api/tenants/members/{memberId} for ownership transfer or
 * full member updates.
 *
 * @remarks
 * This hook is NOT used for inline cell editing (role, area, expiration).
 * A dedicated PATCH endpoint for inline edits is pending backend implementation.
 */
export function useUpdateMember() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({ memberId, payload }: { memberId: string; payload: UpdateMemberPayload }) =>
      membersService.update(memberId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MEMBERS_KEYS.byOrg(orgId) });
    },
  });
}
